import * as React from "react";
const SvgSearchicon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 11, r: 8 }), /* @__PURE__ */ React.createElement("path", { d: "m21 21-4.35-4.35" }));
export default SvgSearchicon;
